import { updateMailingListSubscription } from '@api/apiCalls'
import { identify } from '@helpers/analytics'

type UpdateNewsletterSubscriptionProps = {
  method?: 'subscribe'
  email?: string
  phoneNumber?: string
  location?: string
  includedChannels?: ('email' | 'sms')[]
  overrideListId?: {
    email?: string
    sms?: string
  }
  turnstileToken?: string
}

export default async function updateNewsletterSubscription({
  method = 'subscribe',
  email,
  phoneNumber = undefined,
  location = '',
  includedChannels = ['email', 'sms'],
  overrideListId,
  turnstileToken
}: UpdateNewsletterSubscriptionProps) {
  const isOptedIn = method === 'subscribe'

  if (email) {
    const identifyProps = {
      email,
      ...(!isOptedIn && {
        $source: `Unsubscribed - ${location}`
      })
    }

    identify(null, { ...identifyProps })
  }

  try {
    await updateMailingListSubscription({
      method,
      email,
      phoneNumber,
      source: location,
      includedChannels,
      overrideListId,
      turnstileToken
    })

    return false
  } catch {
    return true
  }
}
